// extracted by mini-css-extract-plugin
export default {"root":"TermsAndConditionsClientPage_root__K1EbB","content":"TermsAndConditionsClientPage_content__XuuQe"};